import Button, { ButtonType } from 'inquiry/components/Button';
import { useApply } from 'inquiry/lib/jsonLogic';
import { ButtonCancelComponent } from 'lib/interfaces/ui-components';
import { HolderClient } from 'verify/lib/clients/HolderClient';
import { UiComponentActionsApi } from 'verify/lib/interfaces/uiComponent';
import { Inquiry } from 'verify/models/inquiry';

interface ButtonCancelProps {
  component: ButtonCancelComponent;
  inquiry: Inquiry;
  actionsApi: UiComponentActionsApi;
  inquiryLoading: boolean;
}

const ButtonCancel = ({ component, inquiry, actionsApi, inquiryLoading }: ButtonCancelProps) => {
  const { 'button-type': buttonType, disabled, hidden, text } = component.attributes;

  const apply = useApply(component.name, inquiry.attributes['next-step'].name);

  // Follow same rules as ConnectedNavbar for whether or not to display close
  // buttons.
  if (!HolderClient.isDashboardFLE && (HolderClient.isHosted || HolderClient.isInline)) {
    return null;
  }

  if (apply<boolean>(hidden)) {
    return null;
  }

  // Note: it's best practice to ensure the component that disables the button
  // is required. So if a user manually submits via devtools or something, the
  // transition will still fail. Without this, the button disable is a purely
  // UI level thing and can be trivially bypassed.
  const isDisabled = inquiryLoading || apply<boolean>(disabled);

  return (
    <Button
      id={component.name}
      type='button'
      buttonType={buttonType ?? ButtonType.Primary}
      onClick={() => actionsApi.onCancel()}
      disabled={isDisabled}
      styles={component?.styles}
    >
      {text}
    </Button>
  );
};

export default ButtonCancel;
